import { supabase } from '../config/supabase';

function extractSessionId(roomUrl) {
  if (!roomUrl || typeof roomUrl !== 'string') return null;
  return roomUrl.split('?')[0].split('/').pop() || null;
}

export async function saveSessionContext({
  roomUrl,
  patientName,
  emiratesId,
  llmProvider,
}) {
  const sessionId = extractSessionId(roomUrl);
  if (!sessionId) {
    console.warn('⚠️ Could not extract session id from room URL');
    return;
  }

  const expiresAt = new Date(Date.now() + 60 * 60 * 1000).toISOString();
  const payload = {
    session_id: sessionId,
    patient_name: patientName || null,
    emirates_id: emiratesId || null,
    status: 'active',
    expires_at: expiresAt,
  };

  if (llmProvider === 'sarah' || llmProvider === 'david') {
    payload.llm_provider = llmProvider;
    payload.consultant = llmProvider;
  } else if (llmProvider === 'gemini') {
    payload.llm_provider = 'david';
    payload.consultant = 'david';
  }

  const { error } = await supabase
    .from('session_context')
    .upsert(payload, { onConflict: 'session_id' });

  if (error) {
    console.warn('⚠️ Failed to save session context:', error.message);
    return;
  }

  console.log('✅ Saved session context:', {
    sessionId,
    llmProvider: payload.llm_provider || 'unchanged',
  });
}
